/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Confirm_Invite_Code_TitleInputs */

const en_dialog_confirm_invite_code_title = /** @type {(inputs: Dialog_Confirm_Invite_Code_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter This Invite Code?`)
};

const ar_dialog_confirm_invite_code_title = /** @type {(inputs: Dialog_Confirm_Invite_Code_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إدخال رمز الدعوة هذا؟`)
};

const de_dialog_confirm_invite_code_title = /** @type {(inputs: Dialog_Confirm_Invite_Code_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diesen Einladungscode eingeben?`)
};

const es_dialog_confirm_invite_code_title = /** @type {(inputs: Dialog_Confirm_Invite_Code_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Introducir este código de invitación?`)
};

const fr_dialog_confirm_invite_code_title = /** @type {(inputs: Dialog_Confirm_Invite_Code_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saisir ce code d’invitation ?`)
};

const it_dialog_confirm_invite_code_title = /** @type {(inputs: Dialog_Confirm_Invite_Code_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserire questo codice invito?`)
};

const ja_dialog_confirm_invite_code_title = /** @type {(inputs: Dialog_Confirm_Invite_Code_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この招待コードを入力しますか？`)
};

const ko_dialog_confirm_invite_code_title = /** @type {(inputs: Dialog_Confirm_Invite_Code_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 초대 코드를 입력할까요?`)
};

const pt_br_dialog_confirm_invite_code_title = /** @type {(inputs: Dialog_Confirm_Invite_Code_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserir este código de convite?`)
};

const ru_dialog_confirm_invite_code_title = /** @type {(inputs: Dialog_Confirm_Invite_Code_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ввести этот код приглашения?`)
};

const th_dialog_confirm_invite_code_title = /** @type {(inputs: Dialog_Confirm_Invite_Code_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กรอกรหัสเชิญนี้หรือไม่?`)
};

const tr_dialog_confirm_invite_code_title = /** @type {(inputs: Dialog_Confirm_Invite_Code_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu davet kodu girilsin mi?`)
};

const zh_cn_dialog_confirm_invite_code_title = /** @type {(inputs: Dialog_Confirm_Invite_Code_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输入此邀请码？`)
};

const zh_tw_dialog_confirm_invite_code_title = /** @type {(inputs: Dialog_Confirm_Invite_Code_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`輸入此邀請碼？`)
};

/**
* | output |
* | --- |
* | "Enter This Invite Code?" |
*
* @param {Dialog_Confirm_Invite_Code_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_confirm_invite_code_title = /** @type {((inputs?: Dialog_Confirm_Invite_Code_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Confirm_Invite_Code_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_confirm_invite_code_title(inputs)
	if (locale === "ar") return ar_dialog_confirm_invite_code_title(inputs)
	if (locale === "de") return de_dialog_confirm_invite_code_title(inputs)
	if (locale === "es") return es_dialog_confirm_invite_code_title(inputs)
	if (locale === "fr") return fr_dialog_confirm_invite_code_title(inputs)
	if (locale === "it") return it_dialog_confirm_invite_code_title(inputs)
	if (locale === "ja") return ja_dialog_confirm_invite_code_title(inputs)
	if (locale === "ko") return ko_dialog_confirm_invite_code_title(inputs)
	if (locale === "pt_br") return pt_br_dialog_confirm_invite_code_title(inputs)
	if (locale === "ru") return ru_dialog_confirm_invite_code_title(inputs)
	if (locale === "th") return th_dialog_confirm_invite_code_title(inputs)
	if (locale === "tr") return tr_dialog_confirm_invite_code_title(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_confirm_invite_code_title(inputs)
	return zh_tw_dialog_confirm_invite_code_title(inputs)
});